import React, { useEffect, useState } from "react";
import { useId24 } from "../../drivers/id24/Id24Provider";
import {
  Button,
  Card,
  Form,
  Input,
  message,
  Modal,
  Select,
  Skeleton,
  Table,
  TablePaginationConfig,
  Typography,
} from "antd";
import { LuckyManagementService } from "./services/lucky-management.service";
import { Activityservice } from "../activity-list/services/importfile.service";
import { useForm } from "antd/lib/form/Form";
import Meta from "antd/es/card/Meta";
import { loadAppConfig } from "../../configs/app-config";

type Tlucky = {
  id: number;
  nameLucky: string;
  agendaId: string;
};
export const IndexLuckyManagement: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const [form] = useForm();
  const [dataLucky, serDataLucky] = useState<Tlucky[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activityAll, setActivityAll] = useState<any[]>([]);
  const [pagination, setPagination] = useState<{
    current: number;
    pageSize: number;
  }>({ current: 1, pageSize: 10 });

  useEffect(() => {
    loadData();
  }, [loading]);

  const loadData = async () => {
    const resLuckyAll = await LuckyManagementService(apiBaseUrl).findAll();
    const resActivity = await Activityservice(apiBaseUrl).getlistActivityAll();
    serDataLucky(resLuckyAll);
    setActivityAll(resActivity);
    setLoading(false);
  };
  async function onUpdateUserFromImport(agendaId: string, luckyId: number): Promise<void> {
    const resActivity = await LuckyManagementService(
      apiBaseUrl
    ).createUsersFromImport({ agendaId: agendaId, luckyId: luckyId });
    if(resActivity){
      message.success(`เพิ่มผู้มีสิทธิ์ : ${resActivity?.success}/ ${resActivity?.total} `)
    }else{
      message.error('ผิดพลาด')
    }
  }
  const columns = [
    {
      title: "หมายเลขรางวัล",
      dataIndex: "id",
      key: "id",
      width: "20%",
      render: (d: string, r: any, index: number) =>
        index + 1 + (pagination.current - 1) * pagination.pageSize,
    },
    {
      title: "ชื่อรางวัล",
      dataIndex: "nameLucky",
      key: "nameLucky",
      width: "50%",
    },
    {
      title: "อัพเดทรายชื่อผู้เข้าร่วม",
      dataIndex: "id",
      key: "id",
      render: (value: number, record: Tlucky) => (
        <Button
          type="link"
          onClick={() => onUpdateUserFromImport(record.agendaId, record.id)}
        >
          อัพเดท
        </Button>
      ),
    },
    {
      title: "รายชื่อผู้เข้าร่วม",
      dataIndex: "id",
      key: "id",
      render: (value: number, record: Tlucky) => (
        <a href={`lucky-management/${value}/${record.agendaId}`}>รายละเอียด</a>
      ),
    },
    {
      title: "รายชื่อผู้ได้รับรางวัล",
      dataIndex: "id",
      key: "id",
      render: (value: number, record: Tlucky) => (
        <a href={`lucky-management/winner/${value}/${record.agendaId}`}>
          รายละเอียด
        </a>
      ),
    },
  ];

  const onChangeTable = (pagination: TablePaginationConfig) => {
    const { current, pageSize } = pagination;
    setPagination({ current: current || 1, pageSize: pageSize || 10 });
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    const dataCreate = form.getFieldsValue();
    await LuckyManagementService(apiBaseUrl).createLucky(dataCreate);
    form.resetFields();
    setLoading(true);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return loading ? (
    <Card className="w-full">
      <Skeleton loading={loading} avatar active>
        <Meta
          avatar={<img src="https://joeschmoe.io/api/v1/random" alt="avatar" />}
          title="Card Title"
          description="Card description"
        />
      </Skeleton>
    </Card>
  ) : (
    <Card className="w-full">
      <Typography className="mb-5 text-[20px] font-bold">{`กลุ่มของรางวัล`}</Typography>
      <Button type="primary" onClick={showModal}>
        เพิ่มรางวัล
      </Button>
      <Table
        dataSource={dataLucky}
        columns={columns}
        rowKey={"id"}
        onChange={onChangeTable}
        pagination={{
          ...pagination,
          defaultPageSize: 10,
          total: dataLucky.length,
          showSizeChanger: true,
        }}
      />
      <Modal
        title="กลุ่มของรางวัล"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form form={form}>
          <Form.Item
            name={"agendaId"}
            label="Activity"
            rules={[{ required: true }]}
          >
            <Select
              className="w-1/2"
              options={activityAll.map((item: any) => ({
                label: item.name,
                value: item.agendaId,
              }))}
              allowClear
            />
          </Form.Item>
          <Form.Item
            name={"nameLucky"}
            label="Name Lucky"
            rules={[{ required: true }]}
          >
            <Input placeholder="Name Lucky" />
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};
